import { ICategoryResult } from './categories';

export interface ISearchResult {
    title: string;
    url: string;
    revisedDate: Date;
    shortDescription: string;
    hitType: string;
    hitId: string;
    friendlyUrl: string;
    viewableByEveryone: boolean;
    openInNewTab: boolean;
}

export interface IResults {
    loading: boolean;
    currentPage: number;
    searchItemList: ISearchResult[];
    categories: ICategoryResult[];
    totalNumber: number;
    totalPages: number;
    errorMessage: string;
    errorType: IErrorType;
    showResults: boolean;
    trackingId: string;
    noResultsWYSIWYG: string;
}

export enum IErrorType {
    NONE,
    GENERAL,
    TIME_OUT
}